import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { TopicCustomFieldsSettings } from '../settings/TopicCustomFields';
import { PublishingSettings } from '../settings/Publishing';
import { InkSection } from '../cms/shared';
import { ArticleAddressRepairs } from '../cms/ArticleAddressRepairs';

/**
 * Website → Articles → Settings (backlog 46b884ba): what's particular to articles.
 * Taxonomy is Prism AI's and the copy edit is set in Voice & style, so here it's
 * only said. Each editor asks before the page is left with changes unsaved.
 */
export function ContentSettings() {
  useEffect(() => {
    const id = window.location.hash.replace('#', '');
    if (!id) return;
    document.getElementById(id)?.scrollIntoView({ block: 'start' });
  }, []);

  return (
    <main className="ink-body">
      <Link to="/content?view=articles" className="ink-muted" style={{ textDecoration: 'none' }}>
        ← Articles
      </Link>
      <h1 className="ink-h1" style={{ marginTop: 10 }}>
        Article settings
      </h1>
      <p className="ink-lede" style={{ paddingBottom: 12 }}>
        How articles are structured, and the checks they pass before going live. Agents read these
        too.
      </p>
      <ArticleAddressRepairs />
      <InkSection
        id="fields"
        title="Custom fields"
        description="Extra structured data for each article. These are visible only to this account."
      >
        <TopicCustomFieldsSettings embedded />
      </InkSection>
      <InkSection
        id="publishing"
        title="Copy edit"
        description="Whether articles and pages need one before going live."
      >
        <PublishingSettings embedded />
      </InkSection>
    </main>
  );
}
